import CPFUtils from '@/core/utils/CPFUtils'
import CNPJUtils from '@/core/utils/CNPJUtils'

export default class FormUtils {
	static validadores = {
		telefone(telefone) {
			const pattern = /^\([1-9]{2}\) (?:[2-8]|9[0-9])[0-9]{3}-[0-9]{4}$/g
			return pattern.test(telefone) || 'Número de telefone inválido!'
		},
		email(email) {
			return !!email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g) || 'E-mail inválido!'
		},
		cpfCnpj(cpfCnpj) {
			const cpfCnpjSemMascara = FormUtils.removerMascaraInput(cpfCnpj) || ''
			if (cpfCnpjSemMascara.length <= 11) {
				return CPFUtils.isValidCPF(cpfCnpj) || 'CPF informado não é valido!'
			}
			return CNPJUtils.isValidCNPJ(cpfCnpj) || 'CNPJ informado não é valido!'
		},
		cnpj(cnpj) {
			return CNPJUtils.isValidCNPJ(cnpj) || 'CNPJ informado não é valido!'
		},
		required(value) {
			return !!value || 'O campo é obrigatório!'
		},
		tamanho(tamanho) {
			return {
				minLength(value) {
					return value.length >= tamanho || `Tamanho mínimo de ${tamanho} caractere(s)`
				},
				maxLength(value) {
					return value.length <= tamanho || `Tamanho máximo de ${tamanho} caractere(s)`
				},
				maior(value) {
					return value > tamanho || !value
				},
				menor(value) {
					return value < tamanho || !value
				},
			}
		},
	}

	static mascaras = {
		telefone: (value) => {
			if (value.length < 15) return '(##) ####-####'
			return '(##) #####-####'
		},
		cpfCnpj: (value) => {
			const cpfCnpjSemMascara = FormUtils.removerMascaraInput(value) || ''
			if (cpfCnpjSemMascara.length <= 11) return '###.###.###-##'
			return 'XX.XXX.XXX/XXXX-##'
		},
		cnpj: () => {
			return 'XX.XXX.XXX/XXXX-##'
		},
	}

	static removerMascaraInput(input) {
		if (typeof input === 'string') {
			return input.replace(/[^a-zA-Z0-9]/g, '')
		}
		return input
	}

	static aplicarMascaraNumero(input) {
		if (!input) return ''
		input = input.replace(/\D/g, '')
		const ddd = input.substring(0, 2)
		const telefone = input.substring(2)

		if (telefone.length === 8) return `(${ddd}) ${telefone.substring(0, 4)}-${telefone.substring(4)}`
		if (telefone.length === 9) return `(${ddd}) ${telefone.substring(0, 5)}-${telefone.substring(5)}`
		return ''
	}

	static obterFormularioSemMascara(form) {
		const formSemMascara = {}
		Object.keys(form).forEach((key) => {
			formSemMascara[key] = this.removerMascaraInput(form[key])
		})
		return formSemMascara
	}
}
